import { useMemo } from "react";
import { useSelector } from "react-redux";

import {
  selectTotalCheckoutValue,
  selectTotalWeight,
} from "~/features/cart/cart/redux/selectors/checkoutPageSelectors";
import { selectTotalCartPriceWithoutDiscount } from "~/features/cart/cart/redux/selectors/cartSelectors";
import { KAMELEOON_FLAGS, useKameleoonFlag } from "~/common/config/kameleoonFlags";
import {
  selectCartContainsSurcharge,
  selectCartContainsTariffSurcharge,
  selectCartSurcharge,
} from "~/features/cart/cart/redux/selectors/cartSelectors";
import {
  selectCheckoutOrderablesViewModel,
  selectCheckoutBundleViewModels,
  selectQuotablesViewModel,
} from "~/features/cart/cartV2/redux/selectors/cartTableSelectors";

export function useCheckoutCartViewModel() {
  const campaignDiscountEnabled = useKameleoonFlag(KAMELEOON_FLAGS.campaigndiscount);
  const totalDiscountSelector = useMemo(
    () => selectTotalCartPriceWithoutDiscount(campaignDiscountEnabled),
    [campaignDiscountEnabled],
  );
  const totalWeight = useSelector(selectTotalWeight);
  const totalSum = useSelector(selectTotalCheckoutValue);
  const totalDiscount = useSelector(totalDiscountSelector);
  const hasAnySurcharge = useSelector(selectCartContainsSurcharge);
  const hasAnyTariffSurcharge = useSelector(selectCartContainsTariffSurcharge);
  const surchargeValue = useSelector(selectCartSurcharge);

  const orderablesViewModel = useSelector(selectCheckoutOrderablesViewModel);
  const bundleViewModels = useSelector(selectCheckoutBundleViewModels);
  const quotablesViewModel = useSelector(selectQuotablesViewModel);

  return {
    totalWeight,
    totalSum,
    totalDiscount,
    hasAnySurcharge,
    hasAnyTariffSurcharge,
    surchargeValue,
    orderablesViewModel,
    bundleViewModels,
    quotablesViewModel,
  };
}
